/**
 * Javascript file for the event recommendations page
 * @author Eduardo Parducci, Andrea Villeda
 */

import {
    getEventRecommendationsBasedOnLocation,
    getEventRecommendationsBasedOnSectorAndLocation,
    getEventRecommendationsBasedOnSector,
    getCompanyProfile,
} from "../../../../api";
export default {
    name: "EventRecommendations",

    /**
     * The vue instance's data object.
     * @property {boolean} sector - The company's sector.
     * @property {boolean} location - The company's location.
     * @property {object} profile - The company's profile.
     * @property {any[]} events - The result set for the recommended events.
     * @property {boolean} loading - Information is currently being loaded.
     */
    data() {
        return {
            sector: true,
            location: true,
            profile: null,
            events: [],
            loading: false,
        };
    },

    /**
     * The vue instance's method declaration.
     */
    methods: {
        /**
         * Returns to the previously visited page.
         */
        goBack() {
            this.$router.go(-1);
        },

        /**
         * Shortens the description passed in the parameters.
         * @param {*} desc - The description.
         */
        shorten(desc) {
            if (desc) {
                var res = desc.substring(0, 500) + "...";
                return res;
            }
            return "";
        },

        /**
         * Retrieves the matching recommendations.
         */
        getRecommendations() {
            if (this.sector && this.location) {
                this.getBySectorAndLocation();
            } else if (this.sector) {
                this.getBySector();
            } else if (this.location) {
                this.getByLocation();
            } else {
                this.events = [];
            }
        },

        /**
         * Returns the matching recommendations based on the specified location.
         */
        getByLocation() {
            this.loading = true;
            this.events = [];
            getEventRecommendationsBasedOnLocation()
                .then((res) => {
                    if (res.length == 0) {
                        this.loading = false;
                    } else {
                        for (let j = 0; j < res.length; j++) {
                            //console.log(res);
                            this.events.push(res[j]);
                            this.loading = false;
                        }
                    }
                })
                .catch((err) => {
                    //console.log(err);
                    this.loading = false;
                });
        },

        /**
         * Returns the matching recommendations based on the specified sector.
         */
        getBySector() {
            this.loading = true;
            this.events = [];
            this.loading = true;
            getEventRecommendationsBasedOnSector()
                .then((res) => {
                    if (res.length == 0) {
                        this.loading = false;
                    } else {
                        for (let j = 0; j < res.length; j++) {
                            //console.log(res);
                            this.events.push(res[j]);
                            this.loading = false;
                        }
                    }
                })
                .catch((err) => {
                    //console.log(err);
                    this.loading = false;
                });
        },

        /**
         * Returns the matching recommendations based on the specified location and sector.
         */
        getBySectorAndLocation() {
            this.loading = true;
            this.events = [];
            this.loading = true;
            getEventRecommendationsBasedOnSectorAndLocation()
                .then((res) => {
                    if (res.length == 0) {
                        this.loading = false;
                    } else {
                        for (let j = 0; j < res.length; j++) {
                            console.log(res);
                            this.events.push(res[j]);
                            this.loading = false;
                        }
                    }
                })
                .catch((err) => {
                    //console.log(err);
                    this.loading = false;
                });
        },
    },

    /**
     * Expression to watch.
     */
    watch: {
        sector: function (val) {
            this.getRecommendations();
        },
        location: function (val) {
            this.getRecommendations();
        },
    },

    /**
     * Called after the instance has been created.
     */
    created() {
        this.loading = true;
        getEventRecommendationsBasedOnSectorAndLocation()
            .then((res) => {
                if (res.length == 0) {
                    this.loading = false;
                } else {
                    for (let j = 0; j < res.length; j++) {
                        //console.log(res);
                        this.events.push(res[j]);
                        this.loading = false;
                    }
                }
            })
            .catch((err) => {
                //console.log(err);
                this.loading = false;
            });
    },
};


// WEBPACK FOOTER //
// ./src/components/company/profile/events/events.js